module.exports = __webpack_public_path__ + "img/lrc-home.ba8b52ba.png";